import React from 'react';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { SimpleTreeView } from '@mui/x-tree-view/SimpleTreeView';

export { ToggleButton, ToggleButtonGroup };

export function TreeView({
  defaultCollapseIcon,
  defaultExpandIcon,
  defaultExpanded,
  children,
  ...props
}) {
  return (
    <SimpleTreeView
      {...props}
      defaultExpandedItems={defaultExpanded}
      slots={{ collapseIcon: () => defaultCollapseIcon, expandIcon: () => defaultExpandIcon }}
    >
      {children}
    </SimpleTreeView>
  );
}

